import React from "react"
import {connect} from "react-redux"

import ComponentWithData from "~/utils/ComponentWithData"

import {Product} from "~/utils/"
import {
  List,
  BarcodeDetailInfoRow,
  DetailInfoRow,
  ListItemArticle,
  Button
} from "~/components/"
import {displayCHF} from "../../helpers/number"
import {OrderProductBox} from "~/components/domain/OrderProductBox"
import {withTranslation} from "react-i18next"

const icon = require("~/icons/product_32_blue.svg")

class ProductDetailView extends ComponentWithData {
  getData() {
    return Product.find(this.props.match.params.product_id)
  }

  renderLoading() {
    return <p>{this.props.t("products.detail.loading")}</p>
  }

  renderError() {
    return (
      <p>
        {this.props.t("products.detail.error")} {console.log(this.state.error)}
      </p>
    )
  }

  renderEmpty() {
    return <p>{this.props.t("products.detail.notFound")}</p>
  }

  renderWithData() {
    return (
      <div className="sh-detail-view">
        <div className="header">
          <div className="title">{this.props.t("products.detail.title")}</div>
          <div className="actions">
            {this.props.admin && (
              <Button
                primary
                to={"/products/" + this.state.data.id}
                label={this.props.t("products.detail.edit")}
              />
            )}
          </div>
        </div>
        <div class="content">
          <DetailInfoRow
            label={this.props.t("products.detail.name")}
            value={this.state.data.name}
          />
          <DetailInfoRow
            label={this.props.t("products.detail.unit")}
            value={this.state.data.unit}
          />
          <DetailInfoRow
            label={this.props.t("products.detail.standardQuantity")}
            value={this.state.data.standard_quantity}
          />

          {this.props.usingNetPrice && (
            <React.Fragment>
              <DetailInfoRow
                label={this.props.t("products.detail.bruttoPrice")}
                value={displayCHF(this.state.data.brutto_price)}
              />
              <DetailInfoRow
                label={this.props.t("products.detail.discountFactor")}
                value={
                  this.state.data.discount_factor &&
                  `${this.state.data.discount_factor}%`
                }
              />
              <DetailInfoRow
                label={this.props.t("products.detail.netPrice")}
                value={displayCHF(this.state.data.net_price)}
              />
            </React.Fragment>
          )}
          <DetailInfoRow
            label={this.props.t("products.detail.productSerialNumber")}
            value={this.state.data.serial_number}
          />
          <DetailInfoRow
            label={this.props.t("products.detail.externalArticleNumber")}
            value={this.state.data.external_article_number}
          />
          {this.props.usingReorderProducts && (
            <React.Fragment>
              <DetailInfoRow
                label={this.props.t("products.detail.reorderQuantity")}
                value={this.state.data.reorder_quantity}
              />
              <DetailInfoRow
                label={this.props.t("products.detail.targetQuantity")}
                value={this.state.data.target_quantity}
              />
              <DetailInfoRow
                label={this.props.t("products.detail.reorderUnitQuantity")}
                value={this.state.data.reorder_unit_quantity}
              />
            </React.Fragment>
          )}

          {this.state.data.barcode && (
            <BarcodeDetailInfoRow value={this.state.data.barcode} />
          )}

          {this.props.mayUseCart && (
            <DetailInfoRow label={this.props.t("products.detail.order")}>
              <OrderProductBox
                product={this.state.data}
                tenant={this.props.subdomain}
              />
            </DetailInfoRow>
          )}

          <DetailInfoRow label={this.props.t("products.detail.article")}>
            <List
              items={this.state.data.articles}
              itemRenderer={ListItemArticle}
            >
              <div className="empty">
                {this.props.t("products.detail.noArticles")}
              </div>
            </List>
          </DetailInfoRow>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({auth}) => {
  const {user} = auth
  const {subdomain, settings, admin, mayUseCart} = user
  const {
    usingReorderProducts,
    usingNetPrice,
    usingManualProductReorder
  } = settings
  return {
    usingReorderProducts,
    usingNetPrice,
    usingManualProductReorder,
    subdomain,
    admin,
    mayUseCart
  }
}

export default withTranslation()(connect(mapStateToProps)(ProductDetailView))



// WEBPACK FOOTER //
// ./src/views/detail/ProductDetailView.js